export default __webpack_public_path__ + "static/media/etf_hive.3a485dd9.svg";